export const API_URL = process.env.REACT_APP_APIURL
export const APP_NAME = process.env.REACT_APP_NAME

export const CRYPTO_HASH = process.env.REACT_APP_CRYPTO_HASH
